module.exports = __webpack_public_path__ + "img/template20_mobile.679594a2.png";